import { Component, h } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import styles from '../../css/app.css';
import Carousel from '../partials/carousel.jsx';

import { SendGAPageView } from '../../utils-and-data/utils.js';
import appEvents from '../../utils-and-data/events.js';

class BookPages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pages: [],
    }
  }

  componentWillMount() {

  }

  componentDidMount() {
    console.log('book pages mounted:', history);
    
    let currentIndex = 0;
    if (history.state 
      && history.state.panel !== undefined) {

      currentIndex = history.state.panel;
    }

    // Do we have content for the current page?
    if (!this.props.pages[currentIndex].paragraphs) {

      // Kick-off fetches in main app controller:
      // (but only when we dont have the first page)
      this.props.beginLoaders();
    }

    appEvents.emit('getUserMedia');
    SendGAPageView({
      title: `Book (page: ${currentIndex + 1})`,
      path: `/book/page-${currentIndex + 1}`
    });
  }

  slideCallback = (index) => {
    console.log('slide call back!', index);
    history.pushState({ panel: index }, `Page ${index}`, '/book');
    SendGAPageView({
      title: `Book Page: ${index + 1}`,
      path: `/book/page-${index + 1}`
    });
  }

  componentWillUnmount() {

  }

  render() {
    return (
      <Carousel panels={this.props.pages}
        colors={this.props.colors}
        dimensions={this.props.dimensions}
        location={this.props.location} 
        slideCallback={this.slideCallback}
        setLights={this.props.setLights} />
    )
  }
}

// Apply 'react-css-modules' to this react component:
export default CSSModules(BookPages, styles);



// WEBPACK FOOTER //
// ./app/frontend/components/routes/book-pages.jsx